export const IndexPath = '/';

// Organization
export const OrganizationsPath = '/companies';
// Organization child routes
export const OrganizationAddPath = `${OrganizationsPath}/add`;
export const OrganizationPath = `${OrganizationsPath}/:organizationId`;
export const OrganizationAccountsPath = `${OrganizationPath}/users`;
export const OrganizationAccountsVaultsAdminPath = `${OrganizationPath}/vaults`;
export const OrganizationAccountsVaultsBulkEditAdminPath = `${OrganizationPath}/vaults/bulkEditVault`;
export const OrganizationAccountsAliasesPath = `${OrganizationAccountsPath}/:accountId/aliases`;
export const OrganizationDashboardPath = `${OrganizationPath}/dashboard`;
export const OrganizationEditPath = `${OrganizationPath}/edit`;
export const OrganizationDetailsPath = `${OrganizationPath}/details`;
export const OrganizationReportsPath = `${OrganizationPath}/reports`;
export const OrganizationSettingsPath = `${OrganizationPath}/settings`;

// Sub menu of reports
export const OrganizationReportsUsersPath = `${OrganizationPath}/reports/users`;
export const OrganizationReportsUsageAndAccessPath = `${OrganizationPath}/usage&Access`;
export const OrganizationReportsEncryptsDecryptsPath = `${OrganizationPath}/encryptsDecrypts`;
export const OrganizationReportsInstallationsPath = `${OrganizationPath}/installations`;
export const OrganizationReportsNewAccountsPath = `${OrganizationPath}/newAccounts`;
export const OrganizationReportsActiveUsersPath = `${OrganizationPath}/activeUsers`;

// Organization accounts child routes
export const OrganizationAccountAddPath = `${OrganizationAccountsPath}/add`;
export const OrganizationAccountDevicesPath = `${OrganizationAccountsPath}/:accountId/devices`;
export const OrganizationAccountVaultsPath = `${OrganizationAccountsPath}/:accountId/vaults`;
export const OrganizationAccountVaultsBulkEditPath = `${OrganizationAccountsPath}/:accountId/vaults/bulkEditVault`;
export const OrganizationAccountReportsPath = `${OrganizationAccountsPath}/:accountId/encryptsDecrypts`;
export const OrganizationAccountEditPath = `${OrganizationAccountsPath}/:accountId/edit`;
export const OrganizationAccountPath = `${OrganizationAccountsPath}/:accountId`;
export const OrganizationAccountDashboardPath = `${OrganizationAccountsPath}/:accountId/dashboard`;

// Auth routes
export const SignInCallbackPath = '/signin-callback';
export const SignOutPath = '/signout';
export const SignOutCallbackPath = '/signout-callback';

// Profile
export const ProfilePath = '/profile';
// Profile child routes
export const ProfileDashboardPath = `${ProfilePath}/dashboard`;
export const ProfileDevicesPath = `${ProfilePath}/devices`;
export const ProfileVaultsPath = `${ProfilePath}/vaults`;
export const ProfileVaultsBulkEditPath = `${ProfilePath}/vaults/bulkEditVault`;
export const ProfileEditPath = `${ProfilePath}/edit`;
export const ProfileAliasesPath = `${ProfilePath}/aliases`;
export const ProfileAccountPath = `${ProfilePath}/account`;
export const ProfileReportsPath = `${ProfilePath}/reports/encryptsDecrypts`;
export const ProfileUsageAndAccessReportsPath = `${ProfilePath}/reports/usage&Access`;
// URLs for Apps menu
export const AppEBAgentLessUrl = 'https://app.datarock.biz';
export const AppAndroidUrl =
  'https://play.google.com/store/apps/details?id=biz.datarock.control';
export const AppIOSUrl =
  'https://apps.apple.com/us/app/c%C3%B4ntrol/id6740588442';
export const AppMacOSUrl =
  'https://cdn.datarock.biz/installers/mac/C%C3%B4ntrolSetup.dmg';
export const AppWindowsOsUrl =
  'https://cdn.datarock.biz/installers/windows/C%C3%B4ntrolSetup.exe';
export const AppOutLookUrl =
  'https://cdn.datarock.biz/installers/windows/outlook/C%C3%B4ntrolAddin.exe';
export const QuestionMarkUrl = 'https://datarock.biz/support';
